function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.11 9.97002H8.84996C7.80996 9.97002 6.95996 10.82 6.95996 11.86V20.11C6.95996 21.15 7.80996 22 8.84996 22H20.11C21.15 22 22 21.15 22 20.11V11.86C22 10.82 21.15 9.97002 20.11 9.97002ZM20 19.99H8.96996V11.97H20V19.99ZM14.51 18.99H9.97996L13.6 14.46L15.8 17.34L16.77 16.1L19.04 18.98H14.51V18.99ZM9.97996 13.98C9.97996 13.43 10.43 12.98 10.98 12.98C11.53 12.98 11.98 13.43 11.98 13.98C11.98 14.53 11.53 14.98 10.98 14.98C10.43 14.98 9.97996 14.53 9.97996 13.98ZM3.87996 9.27002L4.96996 11.23V15.13L2.21996 10.08C1.98996 9.65002 1.92996 9.15002 2.06996 8.68002C2.20996 8.21002 2.52996 7.82002 2.95996 7.59002L12.86 2.22002C13.75 1.74002 14.88 2.07002 15.36 2.96002L18.07 7.96002H15.9L13.68 3.87002L3.87996 9.27002Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=PictureGallery.js.map